'use client'

import Image from 'next/image'

import { ZAPDetailButton } from '@/app/[locale]/annual-programs/_components/ap-detail'
import { useAPDetailGenderSelection } from '@/app/[locale]/annual-programs/_hooks'

export default function AMVDescription() {
	const handleClick = useAPDetailGenderSelection()

	return (
		<>
			<section className='medante-vital__description wrapper2 mgt-30lg mgt-80 mgb-60 mgb-20lg'>
				<div className='medante-vital__description_content'>
					<p>
						Ročný program Medante Vital je prispôsobený potrebám{' '}
						<b>dospelých, detí aj rodín</b>. K tomu pridávame možnosť ročnej
						starostlivosti špecializovaných ambulancií pre zdravie a jeho udržanie počas
						celého roka.
					</p>
				</div>
			</section>
			<section className='medante-vital__description mgt-20lg mgt-60 mgb-20lg mgb-60'>
				<div className='wrapper2 medante-vital__description_content'>
					<h2>
						<b>Neobmedzené návštevy</b>
						<br />u špecialistov Polikliniky Medante
					</h2>
					<p>
						S ročným programom Medante Vital máte{' '}
						<b>všetky návštevy špecialistov Polikliniky Medante zadarmo</b>.
					</p>

					<ul>
						<li>Dostupné termíny s garanciou termínu u špecialistu do 2 týždňov</li>
						<li>Komfortné objednávanie online</li>
						<li>Dostatok času na vyšetrenie</li>
					</ul>

					<p>Darujte si nadštandardnú starostlivosť o vaše zdravie už dnes.</p>
				</div>

				<img
					className='medante-vital__description_illustration'
					src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/illustrations/long-wave/long-medante-wave-sand-02.svg`}
					alt='Ilustračná vlnka'
				/>
			</section>
			{/* , 'medante-vital__description--reverse' */}
			<section className='medante-vital__description wrapper2  mgt-20lg mgt-60 mgb-20lg mgb-20'>
				<div className='medante-vital__description_content column'>
					<h2>
						<b>20% zľava na ošetrenia</b>
						<br />v stomatologickej ambulancii{' '}
					</h2>
					<p>
						S ročným programom Medante Vital máte ešte lacnejšie{' '}
						<b>stomatologické ošetrenia ako:</b>
					</p>

					<ul>
						<li>Ošetrenia zubných kazov</li>
						<li>Výplne koreňových kanálikov</li>
						<li>Extrakcie zubov</li>
					</ul>

					<p>
						Zvýhodnená cena sa nevzťahuje na protetiku, implantáty a dentálnu hygienu.
					</p>
				</div>

				<div className='medante-vital__description_images column'>
					{/* TODO: V priebehu septembra pošlú nové fotografie, tak ich potom nahradime za tieto */}
					{/* <Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/annual-programs/lekarky-1.webp`}
						alt='Stomatologické ošetrenia'
						height={170}
						width={325}
						className='col-span-1'
						unoptimized={true}
					/>
					<Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/annual-programs/lekarky-2.webp`}
						alt='Stomatologické ošetrenia'
						height={170}
						width={325}
						className='col-span-1'
						unoptimized={true}
					/> */}
					<Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/annual-programs/stomatologicka-ambulancia.webp`}
						alt='Stomatologické ošetrenia'
						height={170}
						width={670}
						className='col-span-2'
						unoptimized={true}
					/>
				</div>
			</section>
			<section className='medante-vital__description wrapper2  mgt-20lg mgt-20 mgb-20lg mgb-60'>
				<div className='medante-vital__description_content'>
					<h2>
						<b>Celoročná starostlivosť</b>
						<br />u všeobecného lekára{' '}
					</h2>
					<p>
						Zverte svoje zdravie lekárovi, ktorému na vás záleží. S ročným programom
						Medante Vital získate:
					</p>

					<ul>
						<li>Akútne termíny do 24 hodín</li>
						<li>Starostlivosť s ohľadom na vaše potreby</li>
						<li>Služby klientskeho centra - osobne, telefonicky či emailom</li>
					</ul>

					<div className='medante-vital__description__buttons'>
						<ZAPDetailButton
							text='Program pre ženu'
							onClick={() => handleClick('female')}
							isPrimary={true}
							color='cyclamen'
						/>

						<ZAPDetailButton
							text='Program pre muža'
							onClick={() => handleClick('male')}
							isPrimary={true}
							color='blue'
						/>
					</div>
				</div>
			</section>
		</>
	)
}
